export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-1.f90c3647.jpg";